// Phase H.12a — Section break block node.
//
// Visual divider that groups contract sections WITHOUT forcing a page break
// (contrast with Page break which inserts a CSS hard page break). Saves to
// HTML as `<hr class="section-break" />` so the WeasyPrint pipeline can
// style it via the existing CSS class.

import { Node, mergeAttributes } from "@tiptap/core";

export const SectionBreakNode = Node.create({
    name: "sectionBreak",
    group: "block",
    atom: true,
    selectable: true,
    draggable: false,

    parseHTML() {
        return [{ tag: "hr.section-break" }];
    },

    renderHTML({ HTMLAttributes }) {
        return ["hr", mergeAttributes(HTMLAttributes, { class: "section-break" })];
    },

    addCommands() {
        return {
            insertSectionBreak:
                () =>
                ({ commands }) =>
                    commands.insertContent({ type: this.name }),
        };
    },
});

export default SectionBreakNode;
